export const STATUS_CONSTANTS = {
	NORMAL: 0,
	MOVING: 1,
	LEAVING: 2,
	REVERT: 3,
	REWINDING: 4,
};
